import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
// Defines the tracker's before-send hook (issue 1599) before its first page view.
import './utils/analytics';
import ErrorBoundary from './components/ErrorBoundary';
import { registerServiceWorker } from './config/serviceWorker';
import { installLeaveGuard } from './pages/authoring/builder/useAutosave';

// Before the router renders, so the sheet builder's leave guard hears the
// browser's Back ahead of the router (#926).
installLeaveGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Offline reading (issue 312). Registered AFTER render is scheduled and only
// in a production build over a secure origin — see config/serviceWorker.js. A
// failure here is silent by design: the site works exactly as it did before,
// which is what makes this an enhancement rather than a dependency.
registerServiceWorker();
